import ReadSmore from "read-smore/dist/index.modern";

export default function initReadSmore() {
    const readSmores = document.querySelectorAll(".read-smore");

    const options = {
        wordsCount: 120,
    };

    ReadSmore(readSmores, options).init();
}
